import axios from "../../config/axiosConfig";
import { CREATE_DEBIT_NOTE_BILL_BASE, GET_DEBIT_NOTE_BILL_BASES, DEBIT_NOTE_BILL_BASE_REQUEST, UPDATE_DEBIT_NOTE_BILL_BASE, DELETE_DEBIT_NOTE_BILL_BASE,
  DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, DEBIT_NOTE_BILL_BASE_REQUEST_SUCCESS, 
  GET_DEBIT_NOTES_BILL_BASES_PAGE} from "../types";
import { Entry_Type } from '@/utils';

export const getDebitNoteBillBaseWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST });
      
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Credit_Account_Id,Item_Id'
      };
      return axios.get("/debit-note-bill-base/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DEBIT_NOTES_BILL_BASES_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDebitNoteBillBases = (include, searchStr, searchCols, limit) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include, search: searchStr, searchCols, limit };
      }
      return axios.get("/debit-note-bill-base/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DEBIT_NOTE_BILL_BASES, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getValidatedIncrementedVchNoDebitNoteBillBase = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/debit-note-bill-base/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDebitNoteBillBaseByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/debit-note-bill-base/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDebitNoteBillBaseById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST });
    
      return axios.get(`/debit-note-bill-base/get/${id}`).then((response) => {
        dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createDebitNoteBillBase = (debitNoteBillBase) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST });
      const newDebitNoteBillBase = {
        ...debitNoteBillBase
      };
      return axios.post("/debit-note-bill-base/add", newDebitNoteBillBase,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_DEBIT_NOTE_BILL_BASE, payload: response.data });
        } else {
          dispatch({
            type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE,
            error: "Debit Note Bill Base create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error; 
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateDebitNoteBillBase = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      return axios.put("/debit-note-bill-base/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DEBIT_NOTE_BILL_BASE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE,
            error: "Debit Note Bill Base update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteDebitNoteBillBase = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      return axios.delete(`/debit-note-bill-base/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_DEBIT_NOTE_BILL_BASE, id: id });
          const include = ['id', 'Vch_No', 'Date', 'Account_Id', 'Credit_Account_Id', 'Invoice_No', 'Invoice_Date', 'Amount', 'Total_Amount', 'Item_Id', 'Ack_No'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { inventory: { debitNoteBillBase: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getDebitNoteBillBaseWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const generateEInvoiceDebitNoteBillBase = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      
      return axios.get(`/debit-note-bill-base/generate-e-invoice/${id}`,{ params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DEBIT_NOTE_BILL_BASE,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.log('generate eway bill error',error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const cancelEInvoiceDebitNoteBillBase = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      return axios.post(`/debit-note-bill-base/cancel-e-invoice/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DEBIT_NOTE_BILL_BASE,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteEInvoiceDebitNoteBillBase = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/debit-note-bill-base/delete-e-invoice-bills", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const sendMailDebitNoteBillBase = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('debitNoteId', mailData.debitNoteId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `debit_node_${mailData.debitNoteId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/debit-note-bill-base/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappDebitNoteBillBase = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('debitNoteId', whatsappData.debitNoteId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `debit_node_${whatsappData.debitNoteId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/debit-note-bill-base/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: DEBIT_NOTE_BILL_BASE_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};


export const getAllSalesBillByInvoiceNoInDebitNoteBillBase = (invNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        invoiceNo: invNo,
      };
      return axios.get(`/debit-note-bill-base/get-all-sales-bill-by-invoice-no`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const getPaymentDetailsByDebitNoteBillBaseId = (id) => {
  return async (dispatch, getState) => {
    try {
      const params = {
        billId: id,
        billType: Entry_Type.DEBIT_NOTE_BILL_BASE
      };
      return axios.get(`/bill-adjustment/get-payment-detail-by-id`, { params })
        .then((response) => {
          return response?.data;
        }).catch((error) => {
          console.error(error);
          throw error;
        });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};